import { css } from "@compiled/react";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";

import { useCrossFlowFrontend } from "@/components/cross-flow/use-cross-flow-frontend";

type CtaButtonProps = {
    readonly text: string;
    readonly ctaButtonUrl: string;
    readonly bgColor: string;
    readonly textColor: string;
    readonly analyticsEventLabel: string;
};

const headerBtnLg = css({
    minWidth: "124px",
    height: "40px",
    display: "inline-block"
});

export const CtaButton = ({
    text,
    ctaButtonUrl,
    bgColor,
    textColor,
    analyticsEventLabel
}: CtaButtonProps) => {
    const { createAnalyticsEvent } = useAnalyticsEvents();
    const { openCrossFlow } = useCrossFlowFrontend(ctaButtonUrl);

    const handleClick = (e: React.MouseEvent) => {
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            attributes: {
                name: `${analyticsEventLabel}`,
                section: "cta-section"
            }
        }).fire();
        if (openCrossFlow) {
            openCrossFlow(e);
        }
    };

    const headerBtnLgPrimaryDarkBlue = css({
        fontFamily: "var(--bxp-charlie-text-font-family)",
        padding: "10px 16px",
        background: bgColor,
        border: "none",
        borderRadius: "4px",
        outline: "none",
        fontWeight: 500
    });

    const headerBtnLgPrimary = css({
        fontFamily: "var(--bxp-charlie-text-font-family)",
        fontWeight: 500,
        fontSize: "16px",
        lineHeight: "20px",
        textAlign: "center",
        color: textColor
    });

    return (
        <div css={headerBtnLg}>
            <a
                onClick={handleClick}
                href={ctaButtonUrl}
                css={[headerBtnLgPrimary, headerBtnLgPrimaryDarkBlue]}
            >
                {text}
            </a>
        </div>
    );
};
